@if (maintenanceService.isInMaintenance()) {
  <lib-maintenance-page />
} @else {
  <lib-loading />

  <ng-template modal>
    <lib-modal-component />
  </ng-template>

  <lib-toast aria-live="polite" aria-atomic="true" />

  <app-header />

  <main>
    <router-outlet />
  </main>

  <app-footer />
}
